








import { Component, Prop, Vue } from 'vue-property-decorator';
import Button from '@/components/Button.vue';
import { Validator } from 'class-validator';
import QRUtils from '@/app/utils/QRUtils';
import AccommodationDeepLink from '@/app/utils/AccommodationDeepLink';

@Component({ components: { Button } })
export default class AccommodationQRScanner extends Vue {
  @Prop({ type: Boolean, default: false })
  public disabled!: boolean;

  @Prop(String)
  public path!: string;

  public isOpen: boolean = false;

  public created(): void {
    (window as any).parent.scannedQRCode = this.onDecode.bind(this);
  }

  public beforeDestroy(): void {
    delete (window as any).parent.scannedQRCode;
  }

  public open(): void {
    if (QRUtils.hasScannerApi()) {
      QRUtils.startScan();
    }
  }

  public close(): void {
    this.isOpen = false;
  }

  public get hasScanner(): boolean {
    return QRUtils.hasScannerApi();
  }

  public onDecode(result: string): void {
    const validator = new Validator();
    if (!validator.isURL(result)) {
      return;
    }

    const url = new URL(result);
    const accommodation = AccommodationDeepLink.buildAccommodation(url);
    if (!accommodation) {
      return;
    }

    this.$emit('code-scanned', accommodation);
    this.close();
  }
}
